const { default: Axios } = require("axios");

Axios.defaults.baseURL = "https://siampiwat-shopperlucky.d2u.be/api";
// Axios.defaults.baseURL = "http://localhost:7200/api";


Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default Axios;
